type DraggableElementProps = {
  position: string;
  isLabel?: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
  className: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  dataTestId?: string;
};

export const DraggableElement = ({
  position,
  isLabel = false,
  onMouseDown,
  className,
  children,
  style,
  dataTestId
}: DraggableElementProps) => {
  const baseClasses = 'absolute cursor-grab active:cursor-grabbing';
  const labelClasses = isLabel
    ? 'top-0 z-20 rounded-xl px-2 text-sm text-white shadow-md'
    : 'top-3 h-16 shadow-lg hover:scale-110 -translate-x-1/2';

  const defaultStyle = isLabel
    ? { left: position, transform: 'translateX(-50%)' }
    : { left: position };

  return (
    <div
      className={`${baseClasses} ${labelClasses} ${className}`}
      style={{ ...defaultStyle, ...style }}
      onMouseDown={onMouseDown}
      data-testid={dataTestId}>
      {children}
    </div>
  );
};
